import qs from 'query-string'
import { useLocation } from 'react-router-dom'

const useQueryString = () => qs.parse(useLocation().search)

export default useQueryString
